import { useTranslation } from 'react-i18next';
import { ListContentIsland, ThreeDSListItemButton } from '@razz-team/ui-web';
import { useActiveThreeDSList } from '../../../api/3ds';

export function ThreeDSList() {
  const { t } = useTranslation();
  const filtered = useActiveThreeDSList();

  if (!filtered.length) return null;

  return (
    <ListContentIsland title={t('Confirm card payments')}>
      {filtered.map((it) => (
        <ThreeDSListItemButton<'a'> key={it.id} href={`/account/3ds/${it.id}`} threeDS={it} />
      ))}
    </ListContentIsland>
  );
}
